import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable no-param-reassign */
import { useQuery } from '@apollo/client';
import { proxyOptions } from '@ballpark/realtime-crdt-mobx';
import { useOffline } from '@ballpark/realtime-plugin-offline';
import { useServer } from '@ballpark/realtime-plugin-server';
import { observer } from 'mobx-react';
import { useReducer } from 'react';
import { useMemoOne } from 'use-memo-one';
import { UserTestResponseUtils, validateResponseDoc, } from '@marvelapp/user-test-creator';
import { RecordWithLoading } from '../../components/Record/Record';
import { Persistence } from '../../docUtils/Persistence';
import { useTokenPermission } from '../../docUtils/useAuthToken';
import { GET_RECORDING_DOWNLOAD } from '../../graphql/queries';
const RecordWithUserTest = observer(function RecordWithUserTest({ response, children, partnerData, }) {
    var _a, _b;
    const permission = useTokenPermission();
    const server = useServer();
    const offline = useOffline();
    // check if offline has synced with DB and whether it had data (loaded an existing test)
    const offlineLoaded = offline.synced && ((_a = offline.document) === null || _a === void 0 ? void 0 : _a.store.clients.size) !== 0;
    // Important, we must wait for offline to sync before considering it loaded as the user may have
    // been offline when they completed the test, and we don't want to ask them to resume if the server
    // thinks we are in-progress but locally they have completed it.
    const isLoadingResponse = (offline.enabled && !offline.synced) || (!offlineLoaded && !server.synced);
    const { data, loading: isFetchingRecording } = useQuery(GET_RECORDING_DOWNLOAD, {
        skip: !(response === null || response === void 0 ? void 0 : response.uuid),
        variables: { uuid: response === null || response === void 0 ? void 0 : response.uuid },
    });
    const downloadRecording = (_b = data === null || data === void 0 ? void 0 : data.userTestResult) === null || _b === void 0 ? void 0 : _b.recordings.download;
    return (_jsx(RecordWithLoading, { response: isLoadingResponse ? null : response, isLoading: isLoadingResponse || isFetchingRecording, permission: permission, partnerData: partnerData, downloadRecording: downloadRecording !== null && downloadRecording !== void 0 ? downloadRecording : null, children: children }));
});
export default observer(function RecordPage({ shareUUID, responseUUID, children, restart, partnerData, }) {
    const [documentNumber, incrementDocumentNumber] = useReducer((x) => x + 1, 0);
    const response = useMemoOne(() => UserTestResponseUtils.createResponseDoc(undefined, proxyOptions), [responseUUID, documentNumber]);
    return (_jsx(Persistence, { document: response, id: responseUUID, shareUUID: shareUUID, validate: validateResponseDoc, onDeleted: restart, resetDocument: incrementDocumentNumber, children: _jsx(RecordWithUserTest, { response: response, partnerData: partnerData, children: children }) }));
});
